export default __webpack_public_path__ + "static/media/CNo.88-0.c99dc4f3.jpg";